// actions/qualificationActions.js
// BUG FIX: this used a standalone axios instance (cookie-only auth),
// unlike the rest of the app's action files which use createApi() from
// utils/apiClient — that shared client also attaches the JWT as a
// Bearer header from localStorage, which is what makes auth work inside
// Capacitor (mobile) and Electron, where cross-origin cookies are
// unreliable/don't persist. Without it, every call in this file would
// silently 401 on mobile/desktop (web was fine, since cookies work
// there).
import createApi from "../utils/apiClient";
const api = createApi();

export const getAllQualifications =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "ALL_QUALIFICATIONS_REQUEST" });
      const { data } = await api.get("/qualifications", { params });
      dispatch({
        type: "ALL_QUALIFICATIONS_SUCCESS",
        payload: data.qualifications,
      });
    } catch (err) {
      dispatch({
        type: "ALL_QUALIFICATIONS_FAIL",
        payload: err.response?.data?.message,
      });
    }
  };

// Admin "Pending Approval" tab
export const getPendingQualifications = () => async (dispatch) => {
  try {
    dispatch({ type: "PENDING_QUALIFICATIONS_REQUEST" });
    const { data } = await api.get("/qualifications/pending");
    dispatch({
      type: "PENDING_QUALIFICATIONS_SUCCESS",
      payload: data.qualifications,
    });
  } catch (err) {
    dispatch({
      type: "PENDING_QUALIFICATIONS_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

export const createQualification = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_QUALIFICATION_REQUEST" });
    const { data } = await api.post("/qualifications", payload);
    dispatch({
      type: "CREATE_QUALIFICATION_SUCCESS",
      payload: data.qualification,
    });
    return data;
  } catch (err) {
    dispatch({
      type: "CREATE_QUALIFICATION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Called from the Add Staff form's "+ type a new value" option.
// Saves as "pending" — does NOT show up in dropdowns until approved.
export const suggestQualification = (name, parent_id) => async (dispatch) => {
  try {
    dispatch({ type: "SUGGEST_QUALIFICATION_REQUEST" });
    const { data } = await api.post("/qualifications/suggest", {
      name,
      parent_id,
    });
    dispatch({
      type: "SUGGEST_QUALIFICATION_SUCCESS",
      payload: data.qualification,
    });
    return data;
  } catch (err) {
    dispatch({
      type: "SUGGEST_QUALIFICATION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const approveQualification = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/qualifications/${id}/approve`);
    dispatch({
      type: "APPROVE_QUALIFICATION_SUCCESS",
      payload: data.qualification,
    });
    return data;
  } catch (err) {
    dispatch({
      type: "APPROVE_QUALIFICATION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const rejectQualification = (id, reason) => async (dispatch) => {
  try {
    const { data } = await api.put(`/qualifications/${id}/reject`, { reason });
    dispatch({
      type: "REJECT_QUALIFICATION_SUCCESS",
      payload: data.qualification,
    });
    return data;
  } catch (err) {
    dispatch({
      type: "REJECT_QUALIFICATION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const updateQualification = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_QUALIFICATION_REQUEST" });
    const { data } = await api.put(`/qualifications/${id}`, payload);
    dispatch({
      type: "UPDATE_QUALIFICATION_SUCCESS",
      payload: data.qualification,
    });
    return data;
  } catch (err) {
    dispatch({
      type: "UPDATE_QUALIFICATION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const deleteQualification = (id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_QUALIFICATION_REQUEST" });
    const { data } = await api.delete(`/qualifications/${id}`);
    dispatch({ type: "DELETE_QUALIFICATION_SUCCESS", payload: id });
    return data;
  } catch (err) {
    dispatch({
      type: "DELETE_QUALIFICATION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// A rejected entry can be resubmitted — resets it back to "pending" so it
// shows up in the Approvals queue again.
export const resubmitQualification = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/qualifications/${id}/resubmit`);
    dispatch({
      type: "RESUBMIT_QUALIFICATION_SUCCESS",
      payload: data.qualification,
    });
    return data;
  } catch (err) {
    dispatch({
      type: "RESUBMIT_QUALIFICATION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Rejected list — shown on the Approvals page so admin/requester can
// review the reason and Resubmit if needed. Stored separately from the
// active dropdown list (state.qualification.rejected) to avoid clobbering it.
export const getRejectedQualifications = () => async (dispatch) => {
  try {
    const { data } = await api.get("/qualifications", {
      params: { status: "rejected" },
    });
    dispatch({
      type: "REJECTED_QUALIFICATIONS_SUCCESS",
      payload: data.qualifications,
    });
  } catch (err) {
    dispatch({
      type: "REJECTED_QUALIFICATIONS_FAIL",
      payload: err.response?.data?.message,
    });
  }
};
